import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { RegionService } from 'src/app/services/region.service';
import { DivisionService } from 'src/app/services/division.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { PaccsbookingService } from 'src/app/services/paccsbooking.service';
import { ExcelService } from 'src/app/services/excel.service';
import { LotteryService } from 'src/app/services/lottery.service';
import { DepartmentType } from 'src/enum/departmenttype';
import { LookUpResponse } from 'src/app/models/lookup';

interface LotteryDashboardRow {
  id: number;
  lotteryDate: string;
  goId: number;
  goName: string;
  schemeId: number;
  schemeName: string;
  componentId: number;
  componentName: string;
  productId: number;
  productName: string;
  totalTarget: number;
  totalApplication: number;
  totalBeneficiary: number;
  villageCount: number;
  status: string;
}

export interface LotteryDrillDownContext {
  lotteryRunId: number;
  financialYearId: number;
  financialYearName: string;
  departmentId: number;
  departmentName: string;
  month: number;
  dbtGoId: number;
  dbtSchemeId: number;
  dbtComponentId: number;
  componentName: string;
  dbtProductId: number;
  lotteryDate: string;
  schemeName: string;
  productName: string;
  goName: string;
}

@Component({
  selector: 'app-lottery-dashboard',
  templateUrl: './lottery-dashboard.component.html',
  styleUrls: ['./lottery-dashboard.component.scss']
})
export class LotteryDashboardComponent implements OnInit {

  form: FormGroup;
  isShow = false;
  loading = false;

  financialYearList: LookUpResponse[] = [];
  filterFinancialYearList: LookUpResponse[] = [];

  monthList: LookUpResponse[] = [
    { key: 4, value: 'April' }, { key: 5, value: 'May' }, { key: 6, value: 'June' },
    { key: 7, value: 'July' }, { key: 8, value: 'August' }, { key: 9, value: 'September' },
    { key: 10, value: 'October' }, { key: 11, value: 'November' }, { key: 12, value: 'December' },
    { key: 1, value: 'January' }, { key: 2, value: 'February' }, { key: 3, value: 'March' }
  ];
  filterMonthList: LookUpResponse[] = this.monthList.slice();

  departmentList: LookUpResponse[] = [];
  filterDepartmentList: LookUpResponse[] = [];

  goList: LookUpResponse[] = [];
  filterGoList: LookUpResponse[] = [];

  schemeList: LookUpResponse[] = [];
  filterSchemeList: LookUpResponse[] = [];

  componentList: LookUpResponse[] = [];
  filterComponentList: LookUpResponse[] = [];

  productList: LookUpResponse[] = [];
  filterProductList: LookUpResponse[] = [];

  displayedColumns: string[] = [
    'lotteryDate', 'schemeName', 'productName', 'goName', 'componentName',
    'villageCount', 'totalTarget', 'totalApplication', 'totalBeneficiary', 'status', 'action'
  ];
  private readonly excelColumns: string[] = [
    'Lottery Date', 'Scheme Name', 'Product Name', 'Go Number', 'Component Name',
    'Lottery Executed Villages', 'Total Target', 'Total Application Received', 'Total Benefitted Count', 'Status'
  ];

  dataSource = new MatTableDataSource<LotteryDashboardRow>([]);

  divisionView = false;
  drillData: LotteryDrillDownContext;

 
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private regionService: RegionService,
    private divisionService: DivisionService,
    private vehicleService: VehicleService,
    private paccsbookingService: PaccsbookingService,
    private excelService: ExcelService,
    private lotteryService: LotteryService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.getFinancialYear(true);
  }

  initializeForm(): void {
    this.form = this.formBuilder.group({
      financialYearId: [null, Validators.required],
      monthId: [0],
      departmentId: [null, Validators.required],
      goId: [0],
      schemeId: [0],
      componentId: [0],
      productId: [0]
    });
  }

  getFinancialYear(refresh: boolean): void {
    this.regionService.getFinYear(refresh).subscribe(result => {
      if (!result) {
        return;
      }
      this.financialYearList = result;
      this.filterFinancialYearList = this.financialYearList.slice();

      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;

      let selectedYear: any;
      if (currentMonth >= 4) {
        selectedYear = this.financialYearList.find((x: any) =>
          Number(x.startYear) === currentYear && Number(x.endYear) === currentYear + 1);
      } else {
        selectedYear = this.financialYearList.find((x: any) =>
          Number(x.startYear) === currentYear - 1 && Number(x.endYear) === currentYear);
      }
      if (!selectedYear && this.financialYearList.length > 0) {
        selectedYear = this.financialYearList[this.financialYearList.length - 1];
      }
      if (selectedYear) {
        this.form.controls['financialYearId'].setValue(selectedYear.key);
      }
      this.getDepartments(true);
    });
  }

  onFinancialYearChange(): void {
    this.departmentList = [];
    this.filterDepartmentList = [];
    this.form.controls['departmentId'].setValue(null);
    this.getDepartments(true);
  }

  onDepartmentChange(): void {
    this.clearGoSchemeComponent();
    this.goLookup();
  }

  private clearGoSchemeComponent(): void {
    this.goList = [];
    this.filterGoList = [];
    this.form.controls['goId'].setValue(0);
    this.clearSchemeComponent();
  }

  private clearSchemeComponent(): void {
    this.schemeList = [];
    this.filterSchemeList = [];
    this.form.controls['schemeId'].setValue(0);
    this.clearComponent();
  }

  private clearComponent(): void {
    this.componentList = [];
    this.filterComponentList = [];
    this.form.controls['componentId'].setValue(0);
    this.clearProduct();
  }

  private clearProduct(): void {
    this.productList = [];
    this.filterProductList = [];
    this.form.controls['productId'].setValue(0);
  }

  private goLookup(): void {
    const financialYearId = this.form.value.financialYearId ?? 0;
    const departmentId = this.form.value.departmentId ?? 0;
    this.paccsbookingService.getGoListbyId(financialYearId, departmentId, true).subscribe(result => {
      this.goList = result || [];
      this.filterGoList = this.goList.slice();

      if (this.filterGoList.length === 1) {
        this.form.controls['goId'].setValue(this.filterGoList[0].key);
        this.onGoChange();
      }
    });
  }

  onGoChange(): void {
    this.clearSchemeComponent();
    this.schemeLookup();
  }

  private schemeLookup(): void {
    const goId = this.form.value.goId ?? 0;
    this.divisionService.getSchemaListbyId(true, goId).subscribe(result => {
      this.schemeList = result || [];
      this.filterSchemeList = this.schemeList.slice();

      if (this.filterSchemeList.length === 1) {
        this.form.controls['schemeId'].setValue(this.filterSchemeList[0].key);
        this.onSchemeChange();
      }
    });
  }

  onSchemeChange(): void {
    this.clearComponent();
    this.componentLookup();
  }

  private componentLookup(): void {
    const goId = this.form.value.goId ?? 0;
    const schemeId = this.form.value.schemeId ?? 0;
    this.divisionService.getComponetListbyId(goId, schemeId, true).subscribe(result => {
      this.componentList = result || [];
      this.filterComponentList = this.componentList.slice();

      if (this.filterComponentList.length === 1) {
        this.form.controls['componentId'].setValue(this.filterComponentList[0].key);
      }
      this.onComponentChange();
    });
  }

  onComponentChange(): void {
    this.clearProduct();
    this.productLookup();
  }

  private productLookup(): void {
    const financialYearId = this.form.value.financialYearId ?? 0;
    const departmentId = this.form.value.departmentId ?? 0;
    const goId = this.form.value.goId ?? 0;
    const schemeId = this.form.value.schemeId ?? 0;
    const componentId = this.form.value.componentId ?? 0;

    if (!goId || !schemeId || !componentId) {
      return;
    }

    this.divisionService.getfilteredProductList(true, financialYearId, departmentId, goId, schemeId, componentId)
      .subscribe(result => {
        this.productList = result || [];
        this.filterProductList = this.productList.slice();
      });
  }

  getDepartments(refresh: boolean): void {
    this.vehicleService.getDepartmentLookupData(refresh).subscribe(result => {
      this.departmentList = result || [];
      this.filterDepartmentList = this.departmentList.slice();

      const smam = this.filterDepartmentList.find(d => d.key === DepartmentType.SMAM);
      if (smam) {
        this.form.controls['departmentId'].setValue(smam.key);
      } else if (this.filterDepartmentList.length === 1) {
        this.form.controls['departmentId'].setValue(this.filterDepartmentList[0].key);
      }

      this.onDepartmentChange();
    });
  }

  showGrid(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    const financialYearId = this.form.value.financialYearId;
    const departmentId = this.form.value.departmentId;
    const monthId = this.form.value.monthId;
    const goId = this.form.value.goId;
    const schemeId = this.form.value.schemeId;
    const componentId = this.form.value.componentId;
    const productId = this.form.value.productId;

    this.loading = true;
    this.lotteryService
      .getDashboardList(financialYearId, departmentId, monthId, goId, schemeId, componentId, productId, true)
      .subscribe((result: LotteryDashboardRow[]) => {
        this.dataSource = new MatTableDataSource<LotteryDashboardRow>(result || []);
        this.isShow = true;
        this.loading = false;
        this.cdr.detectChanges();
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.paginator.firstPage();
      }, () => {
        this.loading = false;
      });
  }

  viewLotteryDetails(row: LotteryDashboardRow): void {
    const financialYearId = this.form.value.financialYearId;
    const departmentId = this.form.value.departmentId;

    this.drillData = {
      lotteryRunId: row.id,
      financialYearId,
      financialYearName: this.lookupValue(this.financialYearList, financialYearId),
      departmentId,
      departmentName: this.lookupValue(this.departmentList, departmentId),
      month: this.form.value.monthId,
      // Government Order / Scheme / Component / Product must reflect the selected
      // table row, not the (possibly "All") filter dropdown values above the grid.
      dbtGoId: row.goId,
      dbtSchemeId: row.schemeId,
      dbtComponentId: row.componentId,
      componentName: row.componentName,
      dbtProductId: row.productId,
      lotteryDate: row.lotteryDate,
      schemeName: row.schemeName,
      productName: row.productName,
      goName: row.goName
    };
    this.divisionView = true;
  }

  private lookupValue(list: LookUpResponse[], key: number): string {
    const match = list.find(x => x.key === key);
    return match ? match.value : '';
  }

  onDrillDownClosed(): void {
    this.divisionView = false;
    this.drillData = null;
  }

  applyFilter(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportAsXLSX(): void {
    const excelList = this.dataSource.filteredData.map(row => ({
      LotteryDate: row.lotteryDate,
      SchemeName: row.schemeName,
      ProductName: row.productName,
      GoNumber: row.goName,
      ComponentName: row.componentName,
      LotteryExecutedVillages: row.villageCount,
      TotalTarget: row.totalTarget,
      TotalApplicationReceived: row.totalApplication,
      TotalBenefittedCount: row.totalBeneficiary,
      Status: row.status
    }));
    this.excelService.exportAsExcelFile(excelList, 'Lottery Dashboard', this.excelColumns);
  }

  clear(): void {
    this.isShow = false;
    this.loading = false;
    this.departmentList = [];
    this.filterDepartmentList = [];
    this.goList = [];
    this.filterGoList = [];
    this.schemeList = [];
    this.filterSchemeList = [];
    this.componentList = [];
    this.filterComponentList = [];
    this.productList = [];
    this.filterProductList = [];
    this.dataSource = new MatTableDataSource<LotteryDashboardRow>([]);
    this.initializeForm();
    this.getFinancialYear(true);
    if (this.searchInput) {
      this.searchInput.nativeElement.value = '';
    }
  }
}
